import { injectable } from 'inversify';
import type { IWasmFeatures, IWasmModulesRegistry } from './Interfaces';
import { loadWasmModule as loadMatSDKModule } from './MatSDK';
import { loadWasmModule as loadImageStackModule } from './ImageStack';
import { loadWasmModule as loadDracoDecoderModule } from './DracoDecoder';
import { loadWasmModule as loadDracoEncoderModule } from './DracoEncoder';

import * as WFD from 'wasm-feature-detect';

type _ModuleLoader = () => Promise<void>;

@injectable()
export class WasmModulesRegistry implements IWasmModulesRegistry {
  private _loaders: Array<_ModuleLoader> = [];

  public constructor() {
    this._loaders.push(loadMatSDKModule);
    this._loaders.push(loadImageStackModule);
    this._loaders.push(loadDracoDecoderModule);
    this._loaders.push(loadDracoEncoderModule);
  }

  public loadAllModules(): Promise<Array<void>> {
    return Promise.all(
      this._loaders.map((loader: _ModuleLoader): Promise<void> => {
        return loader();
      })
    );
  }

  public async detectWasmFeatures(toDetect?: IWasmFeatures): Promise<IWasmFeatures> {
    if (toDetect === undefined) {
      toDetect = {
        bigInt: false,
        bulkMemory: false,
        exceptions: false,
        memory64: false,
        multiValue: false,
        mutableGlobals: false,
        referenceTypes: false,
        saturatedFloatToInt: false,
        signExtensions: false,
        simd: false,
        tailCall: false,
        threads: false
      };
    }
    return {
      bigInt: toDetect.bigInt !== undefined ? await WFD.bigInt() : undefined,
      bulkMemory: toDetect.bulkMemory !== undefined ? await WFD.bulkMemory() : undefined,
      exceptions: toDetect.exceptions !== undefined ? await WFD.exceptions() : undefined,
      memory64: toDetect.memory64 !== undefined ? false /*await WFD.memory64()*/ : undefined,
      multiValue: toDetect.multiValue !== undefined ? await WFD.multiValue() : undefined,
      mutableGlobals: toDetect.mutableGlobals !== undefined ? await WFD.mutableGlobals() : undefined,
      referenceTypes: toDetect.referenceTypes !== undefined ? await WFD.referenceTypes() : undefined,
      saturatedFloatToInt: toDetect.saturatedFloatToInt !== undefined ? await WFD.saturatedFloatToInt() : undefined,
      signExtensions: toDetect.signExtensions !== undefined ? await WFD.signExtensions() : undefined,
      simd: toDetect.simd !== undefined ? await WFD.simd() : undefined,
      tailCall: toDetect.tailCall !== undefined ? await WFD.tailCall() : undefined,
      threads: toDetect.threads !== undefined ? await WFD.threads() : undefined
    };
  }
}
